export default {"src":"/_next/static/media/brand-selected-filter.57f9bbb8.svg","height":10,"width":12,"blurWidth":0,"blurHeight":0};